<script setup lang="ts">
    import { useCommandContext } from './context';

    const context = useCommandContext('CommandEmpty');
</script>

<template>
    <div
        v-if="!context.hasVisibleItems.value"
        data-slot="command-empty"
        class="ui-command-empty"
    >
        <slot />
    </div>
</template>

<style scoped>
    @layer components {
        .ui-command-empty {
            padding: 24px 12px;
            color: var(--color-content-tertiary);
            font-size: var(--text-sm);
            line-height: var(--text-sm--line-height);
            text-align: center;
        }
    }
</style>
